"use client";

import Link from "next/link";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { localizedRoutes } from "@/lib/routes/routes";
import type { Locale } from "@/lib/i18n/config";
import { trackEvent } from "@/utils/analytics";

/**
 * CTA hero. Primaria: prenota call. Secondaria: "Scopri come posso
 * aiutarti" → pagina servizi (dove spiego come aiuto). Copy fissa,
 * server-safe, nessuna dipendenza da flag/localStorage.
 */

type Props = {
  lang: Locale;
};

export function HomeHeroCtas({ lang }: Props) {
  const isItalian = lang === "it";
  const routes = localizedRoutes[lang];
  const bookingLink = `${routes.contacts}#tidycal`;
  const secondaryLink = routes.services;
  const secondaryLabel = isItalian
    ? "Scopri come posso aiutarti"
    : "See how I can help";

  return (
    <div className="flex flex-col sm:flex-row gap-3 xl:gap-4 justify-start sm:max-w-[38rem] mx-0">
      <Button
        variant="hero"
        size="lg"
        className="cta-glow sm:h-14 cursor-pointer"
        asChild
      >
        <Link
          href={bookingLink}
          prefetch={false}
          onClick={() =>
            trackEvent("book_call_click", {
              tool: "tidycal",
              location: "hero",
            })
          }
        >
          {isItalian ? "Prenota una call strategica" : "Book a strategy call"}
          <PhoneCall className="w-4 h-4" />
        </Link>
      </Button>
      <Button
        variant="outline"
        size="lg"
        className="rotating-border sm:h-14 cursor-pointer"
        asChild
      >
        <Link
          href={secondaryLink}
          onClick={() =>
            trackEvent("cta_click", {
              cta_text: secondaryLabel,
              cta_section: "hero",
            })
          }
        >
          <ArrowRight className="w-4 h-4" />
          {secondaryLabel}
        </Link>
      </Button>
    </div>
  );
}
